import httpClient from './http-client';

const endpoint = 'api/activity-reports';

const activityReportsService = {
  getPage: (params) => httpClient.get(endpoint, { params }),

  getById: (id) => httpClient.get(`${endpoint}/${id}`),

  search: (query) => httpClient.get(`${endpoint}/find/${query}`),

  create: (activityReport) => httpClient.post(`${endpoint}`, activityReport),

  update: (activityReport) => {
    const formData = new FormData();
    Object.keys(activityReport).forEach((key) => {
      formData.append(key, activityReport[key]);
    });
    formData.append('is_published', activityReport.is_published ? '1' : '0');
    formData.append('_method', 'put');
    return httpClient.post(`${endpoint}/${activityReport.id}`, formData);
  },

  delete: (activityReport) => httpClient.delete(`${endpoint}/${activityReport.id}`),
};

export default activityReportsService;
